import { Component, Story, Knobs, Accents } from './DocTypes';

const PlaygroundKnobs: Knobs = {
  colourScheme: {
    editor: 'dropdown',
    editorOptions: ['', 'light', 'dark', 'default'],
    default: '',
  },
  size: {
    editor: 'dropdown',
    editorOptions: ['', 'default', 'inline', 'fullWidth'],
    default: '',
  },
  accent: {
    default: '',
    editor: 'dropdown',
    editorOptions: [''].concat(Accents),
  },
  closeable: {
    default: 'false',
    editor: 'checkbox',
  },
  hidden: {
    default: 'false',
    editor: 'checkbox',
  },
  closeTransition: {
    editor: 'dropdown',
    editorOptions: ['', 'none', 'fade', 'slideDown', 'slideUp'],
    default: 'none',
  },
  showDuration: {
    default: '',
    editor: 'number',
  },
};

const PlaygroundStory: Story = {
  title: 'Playground',
  description: 'A simple mobile alert box',
  coreComponent_v3: {
    html: `<div style="padding: 16px 0;">
  <tag3-mobile-alert {{...knobs}} ></tag3-mobile-alert>
</div>`,
    knobs: {
      text: {
        default: 'A useful bit of information',
        editor: 'textbox',
      },
      ...PlaygroundKnobs,
    },
  },
  reactWrapper_v3: {
    jsx: `<div style={{padding: "16px 0" }}>
  <TagMobileAlert {{...knobs}}></TagMobileAlert>
</div>`,
    knobs: {
      text: {
        default: 'A useful bit of information',
        editor: 'textbox',
      },
      ...PlaygroundKnobs,
    },
  },
};

const CustomContentStory: Story = {
  title: 'Custom content',
  description: 'A simple mobile alert box',
  coreComponent_v3: {
    html: `<div style="padding: 16px 0;">
  <tag3-mobile-alert {{...knobs}}>
    <div style="display: flex; align-items: center;">
      <tag3-icon icon='Cheque2' accent='white' size='default'></tag3-icon>
      <span style="margin-left: 16px;">You've been paid!</span>
    </div>
  </tag3-mobile-alert>
</div>`,
    knobs: {
      ...PlaygroundKnobs,
    },
  },
  reactWrapper_v3: {
    jsx: `<div style={{padding: "16px 0" }}>
  <TagMobileAlert {{...knobs}}>
    <div style={{ "display": "flex", "align-items": "center" }}>
      <Tag3Icon icon='Cheque2' accent='white' size='default'></Tag3Icon>
      <span style={{ "margin-left": "16px"}}>You've been paid!</span>
    </div>
  </TagMobileAlert>
</div>`,
    knobs: {
      ...PlaygroundKnobs,
    },
  },
};

export const TagMobileAlertDocs: Component = {
  type: 'component',
  name: 'mobile-alert',
  description: 'Renders a mobile alert element. This is for use on a mobile device.',
  mobileFriendly: true,
  popular: false,
  preRelease: 'beta',
  props: [
    { name: 'text', description: 'The text content to display within the alert', type: 'string' },
    {
      name: 'size',
      description:
        'The sizing of the alert box. Whether inline, full width, or full with a margin.',
      type: 'default | inline | fullWidth',
    },
    {
      name: 'accent',
      description: 'The optional colour of the alert',
      type: 'Accent',
    },
    {
      name: 'closeable',
      description: 'Defines whether the alert can be closed',
      type: 'boolean',
      default: 'false',
    },
    {
      name: 'closeTransition',
      description: 'A transition to apply when the alert closes',
      type: 'none | fade | slideDown | slideUp',
    },
    {
      name: 'showDuration',
      description: 'The number of milliseconds before the alert is automatically closed',
      type: 'number',
    },
    {
      name: 'hidden',
      description: 'Whether the alert is hidden or not',
      type: 'boolean',
      default: 'false',
    },
    {
      name: 'colourScheme',
      description:
        'Dark mode (theme) control. Default for normal browser driven control. Dark | Light to force respective styling regardless of browser setting.',
      type: 'dark | light | default',
      default: 'default',
    },
  ],
  reactPropOverrides: [],
  events: [
    {
      name: 'closed',
      description: 'Raised when the alert has closed',
      parameters: [],
    },
  ],
  methods: [
    {
      name: 'show',
      description: 'Shows the alert',
      parameters: [],
      returnType: 'void',
    },
    {
      name: 'hide',
      description: 'Hides the alert',
      parameters: [],
      returnType: 'void',
    },
  ],
  stories: [PlaygroundStory, CustomContentStory],
};
